(function () {
  'use strict';

  var isCleaning = false;

  function isOrphan(item, mainBundleIds) {
    var props = item.properties || {};
    return (
      props._bundle_role === 'addon' &&
      typeof props._bundle_id === 'string' &&
      props._bundle_id.length > 0 &&
      !mainBundleIds.has(props._bundle_id)
    );
  }

  function rerenderCart() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.refresh === 'function') {
      return drawer.refresh(true);
    }
    var cartItems = document.getElementById('cart-items');
    if (cartItems && typeof cartItems.refresh === 'function') {
      return cartItems.refresh();
    }
    window.location.reload();
    return Promise.resolve();
  }

  function checkAndCleanOrphans() {
    if (isCleaning) return;
    isCleaning = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return null;

        var mainBundleIds = new Set();
        cart.items.forEach(function (item) {
          var p = item.properties || {};
          if (p._bundle_role === 'main' && p._bundle_id) {
            mainBundleIds.add(p._bundle_id);
          }
        });

        var orphanKeys = cart.items
          .filter(function (item) { return isOrphan(item, mainBundleIds); })
          .map(function (item) { return item.key; });

        if (!orphanKeys.length) return null;

        var updates = {};
        orphanKeys.forEach(function (k) { updates[k] = 0; });

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (upd) {
          if (!upd.ok) return;
          document.dispatchEvent(new CustomEvent('cart:orphans-cleaned', {
            bubbles: true,
            detail: { removedKeys: orphanKeys }
          }));
          return rerenderCart();
        });
      })
      .catch(function () {})
      .then(function () {
        isCleaning = false;
      });
  }

  document.addEventListener('on:line-item:change', checkAndCleanOrphans);

  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) checkAndCleanOrphans();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndCleanOrphans);
  } else {
    checkAndCleanOrphans();
  }
})();
